module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_vestland_neg.8c28c3a8.svg";